
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";

import { formatDate, getCutoff, inPast, formatDateInWords, penceToCurrency, displayUser, wait, sameDay, BakingIcon, canApproveOrder, MAXIMUM_QUANTITY, RECIPE_PID_ADD, DISH_PID_ADD, getBusinessForDate } from '../../helpers/utils'


import { useHistory } from 'react-router-dom';
import { add, format, sub } from 'date-fns'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLockOpen, faCopy, faCheck, faSave, faSyncAlt, faTimes, faPrint, faFileInvoiceDollar, faFileAlt, faClock, faTruck, faTrashAlt, faExclamationTriangle, faSpinner, faBirthdayCake, faPlus, faSquare, faCheckCircle, faCircle, faCheckSquare, faLock, faPencil, faFileImport, faUserCheck, faUserXmark, faWarning, faArrowRight, faAsterisk, faSpoon } from '@fortawesome/free-solid-svg-icons'

import { supabase } from '../../api'

import { triggerEmail } from '../../pages/Orders/email'
import Modal from "../../components/Modal";
import useModal from "../../helpers/useModal";
import { Calendar } from "react-calendar";
import Photo from "../../components/Photo";
import { useDynamicRefs } from "../../helpers/useDynamicRefs";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";

const customFields = ['sponge','filling','topping','fruit','size','shape','message','notes','unit_cost']

export const OrderForm = ({defaultOrder, shop, products, currentUser, allUsers, currentDate, readOnly, invoiceView = false}) => {

  const history = useHistory();

  const [deleting, setDeleting] = useState(false)
  const { showModal, toggleModal } = useModal()
  const [voiding, setVoiding] = useState(false)
  const [approving, setApproving] = useState(false)
  const { showModal: showDeleteModal, toggleModal: toggleDeleteModal } = useModal()

  const { showModal: showUnapproveModal, toggleModal: toggleUnapproveModal } = useModal()

  const [loading, setLoading] = useState(false)
  
  const [saving, setSaving] = useState(false)
  const [order, setOrder] = useState(defaultOrder)

  const [selectingCopyDate, setSelectingCopyDate] = useState(false)
  const [copyingMessage, setCopyingMessage] = useState('')
  const [copyDate, setCopyDate] = useState()
  const [copying, setCopying] = useState(false)

  const [changes, setChanges] = useState({})

  const [noteChanges, setNoteChanges] = useState({})
  const [temporary, setTemporary] = useState()

  const [cutoffTime, setCutoffTime] = useState()
  const [pastCutOff, setPastCutOff] = useState()
  const [locked, setLocked] = useState(true)

  const defaultShowInvoice = !!order.approved_at || invoiceView

  const [showInvoice, setShowInvoice] = useState(defaultShowInvoice)

  const [editNotes, setEditNotes] = useState(false)

  const dateStr = format(currentDate,'dd-MMM-yyyy')

  const [getRef, setRef] =  useDynamicRefs();


  const businessData = getBusinessForDate(currentDate)

   const getRandom = () => {
        return Math.floor(100000 + Math.random()*899999)
    }

    const [random, setRandom] =  useState(getRandom())

    const updateRandom = () => {
        setRandom(getRandom())
    }
    

  console.log('businessData',businessData)
  const canUnapprove = currentUser?.superadmin || currentUser.p_orders >= 3

  useEffect ( () => {
    async function fetchData() {

        setLoading(true)

        // process changes
        const noteValues = {}
        order.orderProducts?.forEach(op => {
            noteValues[op.products.id] = { note: op.note, backup: op.note || '' }
        })
        setNoteChanges(noteValues)

        
        setLoading(false)

    }
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect ( () => {

    const co = currentUser.admin ? undefined : getCutoff(currentDate)
    const pco = inPast(getCutoff(currentDate))
    setCutoffTime(co)
    setPastCutOff(pco)

    if (currentUser.admin && !order?.id) {
        setLocked(false)
    }
    else {
        setLocked(order?.voided || readOnly || pco)
    }
  
  }, [currentDate, readOnly])



  const showTemporary = async (message) => {

    setTemporary(message)
    await wait(3000)
    setTemporary(undefined)

  }

  const viewOrder = () => {
    history.push(`/orders/${format(currentDate,'dd-MMM-yyyy')}/${order.id}`)
  }

  const changeQuantity = (event, doUpdate, productID, quantityString, unit_cost, quantity_imported) => {

    const canEnterFraction = !!currentUser.admin

    const newChanges = {...changes}

    let quantity = canEnterFraction ? Number(parseFloat(quantityString).toFixed(2)) : parseInt(quantityString)

    if (isNaN(quantity) || quantity < 0) {
        quantity=0
    }
    if (quantity > MAXIMUM_QUANTITY) quantity = MAXIMUM_QUANTITY 


    const beforeQuantity = order.orderProducts?.find(op => op.products.id === productID)?.quantity || 0
    
    if (doUpdate || !canEnterFraction) event.target.value = canEnterFraction ? quantity : parseInt(quantityString)

    if (quantity === beforeQuantity) {
        delete newChanges[productID]
    }
    else {
        newChanges[productID] = { ...newChanges[productID], quantity, unit_cost, quantity_imported, beforeQuantity };
    }

    setChanges(newChanges)

  }

  const changeNote = (productID, note) => {
    const newChanges = {...noteChanges}
    const old = newChanges[productID]
    newChanges[productID] = { ...old, note, updated: old.backup !== note }

    setNoteChanges(newChanges)
  }

  const adminLock = () => {
    setLocked(true)
  }

  const adminUnlock = () => {
      setLocked(false)
  }

  const adminUnapprove = () => {
    toggleUnapproveModal()
  }

  const handleDelete = () => {
    toggleDeleteModal()
  }

  const handleVoid = () => {
    toggleModal()
  }

  const doVoid = async () => {

    if (!currentUser.admin) return false

    setVoiding(true)

    const orderData = {
        ...order,
        voided: true,
        voided_at: new Date().toISOString(),
        voided_by: currentUser.id,
    }

    delete orderData.orderProducts
    delete orderData.orderCustoms
    delete orderData.recipes

    
    const { data, error } = await supabase
        .from('orders')
        .update(orderData)
        .match({ id: order.id })
        .single()
        .select()
    if (error) console.error('error updating order', error)
    if (data) {
        document.location = `/orders/${format(currentDate,'dd-MMM-yyyy')}/${order.id}`
    }
    
  }



  const doDelete = async () => {
    
    if (!currentUser.admin) return false

    setDeleting(true)
    
    const { data: ocData, error: ocError } = await supabase
        .from('orderCustoms')
        .delete()
        .match({ order_id: order.id })

    if (ocError) {
        console.error(ocError)
        return
    }

    const { data: opData, error: opError } = await supabase
        .from('orderProducts')
        .delete()
        .match({ order_id: order.id })

    if (opError) {
        console.error(opError)
        return
    }
    const { data: oData, error: oError } = await supabase
        .from('orders')
        .delete()
        .match({ id: order.id })

    if (oError) {
        console.error(oError)
        return
    }

    await wait(3000)

    setDeleting(false)

    history.push(`/orders/${format(currentDate,'dd-MMM-yyyy')}`)

  }


  const adminApprove = async () => {

    if (!currentUser.admin) return false

    setApproving(true)

    const updateObject = {
        id: order.id,
        approved_at: new Date().toISOString(),
        approved_by: currentUser.id,
    }

    const { error: approvalError } = await supabase
        .from('orders')
        .upsert(updateObject)
    
    if (approvalError) {
        console.error(approvalError)
        setApproving(false)
        return
    }
    
    document.location = `/orders/${format(currentDate,'dd-MMM-yyyy')}/${order.id}`

  }


  const doUnapprove = async () => {

    if (!canUnapprove) return false

    setApproving(true)

    const updateObject = {
        id: order.id,
        approved_at: null,
        approved_by: null,
    }

    const { error: unapprovalError } = await supabase
        .from('orders')
        .upsert(updateObject)
    
    if (unapprovalError) {
        console.error(unapprovalError)
        setApproving(false)
        return
    }
    
    document.location = `/orders/${format(currentDate,'dd-MMM-yyyy')}/${order.id}`

  }

  const hasChanged = (quantityImported, quantity) => {
    if (quantityImported === null && quantity === 0) return false
    return (quantityImported !== quantity)
  }
  
  const isAltered = () => {
    let response = false

    if (!order.imported_at) return false

    for (const op of order.orderProducts) {
        const change = changes[op.products.id]
        const isDifferent = change ? hasChanged(change.quantity_imported, change.quantity) : hasChanged(op.quantity_imported, op.quantity)
        if (isDifferent) {
            response = true 
            break 
        }
    }
    const changeArr = Object.entries(changes)
    for (const change of changeArr) {
        const isDifferent = hasChanged(change[1].quantity_imported, change[1].quantity)
        if (isDifferent) {
            response = true 
            break 
        }
    }
    return response
  }

  const handleSubmit = async () => {
    
    setSaving(true)
    
    const changeArr = Object.entries(changes)

    let productsOrdered = 0
    let productOrderRecords = []

    for (let index = 0; index < changeArr.length; index++) {
        const change = changeArr[index]
        if (change[0]!=='undefined' && !isNaN(change[1].quantity)) {
            productOrderRecords.push( { product_id: parseInt(change[0]), quantity: change[1].quantity, unit_cost: change[1].unit_cost, beforeQuantity: change[1].beforeQuantity } )
            productsOrdered += 1;
        }
    }


    if (productsOrdered === 0 && !order) {
        alert('Order is empty')
        return
    }


    const dateNow = new Date().toISOString()

    const orderData = {
        id: order.id,
        updated_at: dateNow,
        updated_by: currentUser.id,
        notes: order?.notes || '',
        purchase_order_num: order?.purchase_order_num || '',
        is_altered: isAltered(),
    }

    if (!order?.id) { /* new */
        orderData.shop_id = shop.id;
        orderData.delivery_dt = dateStr;
        orderData.created_by = currentUser.id;
        orderData.created_at = dateNow;
        orderData.is_altered = false;
    }

    // sync order record

    const { data: upsertedOrder, error } = await supabase
        .from('orders')
        .upsert(orderData)
        .single()
        .select()

    if (error) console.error('error upserting order', error)
    
    // sync orderProducts records

    if (upsertedOrder?.id) {

        const productOrderRecordsToUpsert = productOrderRecords.map(p => ({
            product_id: p.product_id,
            quantity: p.quantity,
            unit_cost: p.unit_cost,
            order_id: upsertedOrder.id,
            updated_at: new Date().toISOString(),
            updated_by: currentUser.id
        }))

        const { error: poError } = await supabase
            .from('orderProducts')
            .upsert(productOrderRecordsToUpsert)
        if (poError) console.error('error upserting orderProducts', poError)

        // delete empty order products
        const { error: cleanError } = await supabase
            .from('orderProducts')
            .delete()
            .match({ order_id: upsertedOrder?.id, quantity: 0 })
            .is('quantity_imported', null);

        if (cleanError) console.error('error cleaning orderProducts', poError)

        // fetch order again
        const { data: allOrderProducts } = await supabase
        .from('orderProducts')
        .select('*')
        .match({ order_id: upsertedOrder?.id })
        

        if (order?.id) {
            await triggerEmail('UPDATED', upsertedOrder, allOrderProducts, productOrderRecords, shop, currentDate, products, allUsers)
            setOrder({...order, updated_at: upsertedOrder.updated_at, updated_by: upsertedOrder.updated_by})
            showTemporary('Your changes have been saved')
        }
        else {
            await triggerEmail('CREATED', upsertedOrder, allOrderProducts, productOrderRecords, shop, currentDate, products, allUsers)
            showTemporary(`Order ${upsertedOrder.id} created`)
        }

        //reload to saved version
        document.location = `/orders/${format(currentDate,'dd-MMM-yyyy')}/${upsertedOrder.id}`

    }
    else {
        alert('Sorry - your order has not be saved')
    }
    setSaving(false)
  }

  const handleCustomSubmit = async () => {
    
    // get order custom form fields
    
    const orderCustoms = order?.orderCustoms?.map((oc,i) => {
        const obj = {}
        customFields.forEach(f => {
            const val = getRef(`${f}_${i}`).current.value
            obj[f] = val
        })
        obj['unit_cost'] = Math.floor(parseFloat(obj['unit_cost'])*100)
        return obj
    })

    setSaving(true)
    
    const dateNow = new Date().toISOString()

    const orderData = {
        ...order,
        updated_at: dateNow,
        updated_by: currentUser.id,
    }

    if (!order?.id) {
        orderData.shop_id = shop.id;
        orderData.delivery_dt = dateStr;
        orderData.created_by = currentUser.id;
        orderData.created_at = dateNow;
    }

    delete orderData.orderProducts
    delete orderData.orderCustoms
    delete orderData.recipes
    
    // sync order record
    let modifiedOrder = {}

    if (order?.id) {  // update
        const { data, error } = await supabase
          .from('orders')
          .update(orderData)
          .match({ id: order.id })
          .single()
          .select()
        if (error) console.error('error updating order', error)
        if (data) modifiedOrder = data

        console.log(data, error)
    }
    else { // insert

        const { data, error } = await supabase
          .from('orders')
          .insert(orderData)
          .single()
          .select()
        if (error) console.error('error inserting order', error)

    
        if (data) modifiedOrder = data
    }


    if (modifiedOrder?.id) {
        const { data, error } = await supabase
            .from('orderCustoms')
            .delete()
            .match({ order_id: modifiedOrder.id })

        if (error) console.error('error deleting orderCustoms', error)

        const orderCustomRecords = orderCustoms?.map(p => ({...p, order_id: modifiedOrder.id }))
        let orderCustomRecordsSaved = []

        if (orderCustomRecords?.length) {
            const { data: poData, error: poError } = await supabase
                .from('orderCustoms')
                .insert(orderCustomRecords)
                .select()
                .select()
            if (poError) console.error('error inserting orderCustoms', poError)
            if (poData) orderCustomRecordsSaved = poData
        }

        if (order?.id) {
            setOrder({...order, orderCustoms: orderCustomRecordsSaved, updated_at: modifiedOrder.updated_at, updated_by: modifiedOrder.updated_by})
            showTemporary('Your changes have been saved')
        }
        else {
            //reload to saved version
            document.location = `/orders/${format(currentDate,'dd-MMM-yyyy')}/${modifiedOrder.id}`
            showTemporary(`Order ${modifiedOrder.id} created`)
        }

    }
    else {
        alert('Sorry - your order has not be saved')
    }
    setSaving(false)
  }


  const handleNotesSubmit = async () => {

    if (!currentUser.admin) return false

    setSaving(true)

    const resetNoteChanges = {...noteChanges }

    const orderProductRecords = Object.keys(noteChanges).map(key => {

        if (!noteChanges[key].updated) return undefined

        resetNoteChanges[key] = { ...resetNoteChanges[key], updated: false, backup: noteChanges[key].note }
    
        return {
            order_id: order.id,
            product_id: parseInt(key),
            note: noteChanges[key].note
        }
    }).filter(Boolean)
    
    const { error: poError } = await supabase
        .from('orderProducts')
        .upsert(orderProductRecords)
    
    if (!poError) {
        setNoteChanges(resetNoteChanges)
        setEditNotes(false)
    }
    setSaving(false)
  }

  const filterProducts = (products) => {
    //return products
    let filtered

    filtered = products.filter(p => {
        const availableToShop = p.shopProducts.map(s => s.shop_id).includes(shop.id)
        const op = order?.orderProducts?.find(op => op.products.id === p.id)
        return (p.active && availableToShop) || (op && op.quantity>0)
    })

    return filtered
  }



  const duplicate = () => {
    setCopyingMessage('Select the new delivery date')
    setSelectingCopyDate(true)
  }

  const doPrint = async () => {
        adminLock()
        await wait(100)
      window.print()
  }

  const toggleFormat = () => {
    setShowInvoice(v => !v)
  }

  const toggleNotes = () => {
    setEditNotes(v => !v)
  }

  const onSelectDate = async (dt) => {
    
    const newDateCutOff = currentUser.admin ? undefined : getCutoff(new Date(dt))
    const newDateInPast = newDateCutOff && inPast(newDateCutOff)

    if (newDateInPast) {
        setCopyingMessage(`Sorry, the cut off for this date was ${formatDate(newDateCutOff,true)}`)
        setCopyDate()
    }
    else {
        setCopyingMessage('')
        setCopyDate(new Date(dt))
    }

  }

  const doCopy = async () => {

    const newDate = format(copyDate,'yyyy-MM-dd')

    const orderCopyFields = {
        ...order,
        delivery_dt: newDate,
        created_at: new Date(),
        created_by: currentUser.id,
    }

    delete orderCopyFields.id
    delete orderCopyFields.orderProducts
    delete orderCopyFields.orderCustoms
    delete orderCopyFields.recipes

    const { data: newOrder, error: newOrderError } = await supabase
        .from('orders')
        .insert(orderCopyFields)
        .single()
        .select()
    if (newOrderError) console.error('error inserting order', newOrderError)

    if (newOrder) {

        //normal order - order products
        if (newOrder.order_type === 0) {
            const orderProducts = order.orderProducts.map(op => {
                const newOP = { ...op, order_id: newOrder.id, product_id: op.products.id }
                delete newOP.products
                return newOP
            })
            
            const { data, error } = await supabase
                .from('orderProducts')
                .insert(orderProducts)
                .select()
            if (error) console.error('error inserting order products', error)

            if (data) {
                setCopyingMessage(`Order copied to ${formatDate(copyDate)}`)
                setCopyDate()
            }
        }
        //custom order - order customs
        if (newOrder.order_type === 1) {
            const orderCustoms = order.orderCustoms.map(oc => {
                const newOC = { ...oc, order_id: newOrder.id }
                delete newOC.id
                return newOC
            })

            const { data, error } = await supabase
                .from('orderCustoms')
                .insert(orderCustoms)
                .select()
            if (error) console.error('error inserting order customs', error)

            if (data) {
                setCopyingMessage(`Custom order copied to ${formatDate(copyDate)}`)
                setCopyDate()
            }
        }
    }

  
  }

  const onSelectDateCancelled = () => {
    setSelectingCopyDate(false)
    setCopyDate('')
  }

  const handleFocus = (e) => {
      e.target.select()
  }

  const switchType = () => {
    if (order.order_type === 1) {
        setOrder({...order, order_type: 0})
    }
    else {
        setOrder({...order, order_type: 1})
    }
  }

  const statusMessage = () => {

    const delivered = order?.id && inPast(currentDate)
    let message = <span><b>DELIVERED</b></span>
    let status = ''
    let processing = false

    let leftIcon = order.imported_at ? faFileImport : faFileAlt
    if (order?.order_type === 1) leftIcon = faBirthdayCake

    let rightIcon = faCheck

    if (order?.id) status = order?.order_type === 0 ? 'ORDER' : 'CUSTOM ORDER'
    if (!order?.id) status = order?.order_type === 0 ? 'NEW ORDER' : 'NEW CUSTOM ORDER'


    if (pastCutOff) {
        if (order?.id) {
            if (!delivered) {
                processing = true 
                message = <span><b>BAKING!</b><br/>Call for last minute changes</span>
                rightIcon = faSyncAlt;
            }
            else if (sameDay(currentDate, new Date())) {
                message = <span><b>DELIVERED TODAY</b></span>
                rightIcon = faTruck;
            }
        }
        else {
            if (currentUser.admin) {
                message = <span><b>ADMIN</b><br/>Delivery date past cutoff</span>
                rightIcon = faWarning
            }
            else {
                message = <span>You missed the cut off<br/>{formatDate(cutoffTime,true)}</span>
            }
        }
    }
    else  {
        if (order?.id) {
            if (currentUser.admin) {
                message = <span><b>ADMIN</b></span>
            }
            else {
                rightIcon = faClock
                message = <span><b>CHANGES ALLOWED</b><br/>until {formatDate(cutoffTime,true)}</span>
            }
        }
        if (!order?.id) {
            if (currentUser.admin) {
                message = <span><b>ADMIN</b></span>
            }
            else {
                rightIcon = faClock
                message = <span>Cut off is {formatDateInWords(cutoffTime)}<br/>You have until {formatDate(cutoffTime,true)}</span>
            }
        }
    }


    let classList = ['status','no-print']
    if (delivered) classList.push('delivered')
    if (!order?.id) classList.push('new')
    if (processing) classList.push('processing')
    if (order.order_type === 1) classList.push('custom')

    if (order.voided) {
        classList = ['status','voided']
        leftIcon = faTimes
        rightIcon = faTimes
        status = 'VOID'
        message = <span><b>Voided {formatDate(order?.voided_at, false)}</b><br/>this order will not be fullfilled</span>
    }

    if (order.approved_at) {
        classList = ['status','approved']
        rightIcon = faUserCheck
        message = <span><b>APPROVED</b></span>
    }

    return (
        <div className={classList.join(' ')}>
            <div className='left'>
                <FontAwesomeIcon size="2x" icon={leftIcon} /> {status}
                
            </div>
            <div className='locked-status'><FontAwesomeIcon size="2x" icon={locked ? faLock : faLockOpen} /></div>
            <div className='right'>{message} {processing ? <BakingIcon size='2x' /> : <FontAwesomeIcon size="2x" icon={rightIcon} />}</div>
        </div>
    )
  }


  const showBillingAddress = () => {
    const arr = [`${shop.name}${shop.brands?.name ? ` (${shop.brands.name})` : ''}`, shop.billing_line_1, shop.billing_line_2, shop.billing_town, shop.billing_postcode]
    return arr.map(line => line ? <>{line}<br/></> : '')
  }


  const showDeliveryAddress = () => {
      
    let arr = []
    if (order.order_type === 0 || order.deliver_to_shop) arr = [`${shop.name}${shop.brands?.name ? ` (${shop.brands.name})` : ''}`, shop.delivery_line_1, shop.delivery_line_2, shop.delivery_town, shop.delivery_postcode]
    else arr = [order.delivery_customer, order.delivery_company, `Tel: ${order.delivery_tel || ''}`, order.delivery_line_1, order.delivery_line_2, order.delivery_line_3, order.delivery_city, order.delivery_postcode]
    return arr.map(line => line ? <>{line}<br/></> : '')
  }


  const calculateTotals = (withChanges) => {
    let quantityCount = 0
    let totalCount = 0

    products.forEach(productCategory => {
        productCategory[1].forEach(p => {
            const op = order?.orderProducts?.find(op => op.products.id === p.id)
            const change = changes[p.id]
            if (withChanges && change) {
                quantityCount += change.quantity
                totalCount += change.unit_cost * change.quantity
            }
            else if (op) {
                quantityCount += op.quantity
                totalCount += op.unit_cost * op.quantity
            }
        })
    })
    return { quantityCount, totalCount }
  }
  
  
  const showPurchaseOrderNum = !(locked && !order?.purchase_order_num)

  const beforeTotals = calculateTotals(false)
  const totals = calculateTotals(true)

  const quantityCount = Number(parseFloat(totals.quantityCount).toFixed(2))
  
  let grandTotal = 0
  if (order.order_type === 0) grandTotal = totals.totalCount;
  if (order.order_type === 1) grandTotal = order.orderCustoms.reduce((agg, oc) => agg + oc.unit_cost, 0);

  const addCustom = () => {
    const arr = [...order?.orderCustoms, {}]
    setOrder({...order, orderCustoms: arr})
  }

  const renderOrderCustomInvoiceRow = (item, index) => {
  
    const itemCost = penceToCurrency(item.unit_cost)
    return (
        <>
        
        <tr>
            <td>
            <div  className={`order-row`} >
            <input style={{width:'100%', fontWeight:'bold'}} name="product" disabled defaultValue={`Custom Item ${index+1}`} />
            
            <input className='cost' disabled type="number" name="quantity" defaultValue='' />
        

            <input className={`cost`} disabled={true} readOnly name="unit_cost" defaultValue='' />

            <input className={`cost total-cost`} disabled={true} readOnly name="total_cost" value={itemCost} />

            </div>

            </td>
        </tr>
        <tr>
            <td>
                <div className='custom-item-desc'>
                {customFields.map(f => {
                    if (f==='unit_cost') return
                    return (<div>{f}:<br/><strong>{item[f]}</strong></div>)
                })}
                </div>
            </td>
        </tr>
        </>
    )
  }

  const Checklist = ({labels}) => {
    return <div style={{verticalAlign:'bottom'}}  className={`checklist ${labels ? 'labels' : ''}`}><div>{labels ? 'OFFICE' : ''}</div><div>{labels ? 'PROD' : ''}</div></div>
  }
  
  const renderOrderCustom = (item, setRef, index) => {

    const removeItem = () => {
        // eslint-disable-next-line no-restricted-globals
        if (confirm('Remove this item?  Please remove any photo first!')) {
            const items = [...order.orderCustoms]
            items.splice(index, 1)
            setOrder({...order, orderCustoms: items})
        }
    }

    const copyToText = (event,fieldName) => {
        const val = event.target.value

        const ocs = [...order.orderCustoms]
        ocs[index][fieldName] = val

        setOrder({...order, orderCustoms: ocs}) 
    }

    return (
        <div className='custom-item'>
            <h3 className='center'>Custom Item {index+1} </h3>
            {!locked ? <button className='remove-button' disabled={locked} onClick={removeItem}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Remove</button> : ''}

            <table className='clear'>
                <tr>
                    <td className='right'> 
                        <select disabled={locked} value='Sponge' onChange={(e) => copyToText(e,'sponge')} >
                            <option>Sponge</option>
                            <option></option>
                            <option>Chocolate</option>
                            <option>Vanilla</option>
                            <option>Coffee</option>
                            <option>Eggless</option>
                            <option value=''>Other</option>
                        </select>
                    </td>
                    <td key={item.sponge}><input ref={setRef(`sponge_${index}`)} disabled={locked} type='text' name='sponge' defaultValue={item.sponge} /></td>
                    <td className="checklist-column"><Checklist /></td>
                </tr>
                <tr>
                    <td className='right'> 
                        <select disabled={locked} value='Filling' onChange={(e) => copyToText(e,'filling')} >
                            <option>Filling</option>
                            <option></option>
                            <option>Fresh Vanilla Cream</option>
                            <option>Fresh Chocolate Cream</option>
                            <option>Chocolate Mousse</option>
                            <option>Chocolate Butter Cream</option>
                            <option>Vanilla Butter Cream</option>
                            <option>Chocolate Icing</option>
                        </select>
                    </td>
                    <td key={item.filling}><input ref={setRef(`filling_${index}`)} disabled={locked}  type='text' name='filling' defaultValue={item.filling}  /></td>
                    <td className="checklist-column"><Checklist /></td>
                </tr>
                <tr>
                    <td className='right'> 
                        <select disabled={locked} value='Fruit / Jam' onChange={(e) => copyToText(e,'fruit')} >
                            <option>Fruit / Jam</option>
                            <option></option>
                            <option>No Fruit or Jam</option>
                            <option>Fresh Strawberry</option>
                            <option>Strawberry / Banana</option>
                        </select>
                    </td>
                    <td key={item.fruit}><input ref={setRef(`fruit_${index}`)} disabled={locked}  type='text' name='fruit' defaultValue={item.fruit}  /></td>
                    <td className="checklist-column"><Checklist /></td>
                </tr>
                <tr>
                    <td className='right'>  
                        <select disabled={locked} value='Topping' onChange={(e) => copyToText(e,'topping')} >
                            <option>Topping</option>
                            <option></option>
                            <option>Fresh Cream</option>
                            <option>Sugar Paste</option>
                            <option>Marzipan</option>
                            <option>Vanilla Icing</option>
                            <option>Chocolate Icing</option>
                        </select>
                    </td>
                    <td key={item.topping}><input ref={setRef(`topping_${index}`)} disabled={locked} type='text' name='topping' defaultValue={item.topping} /></td>
                    <td className="checklist-column"><Checklist /></td>
                </tr>
                <tr>
                    <td className='right'>  
                        <select disabled={locked} value='Size' onChange={(e) => copyToText(e,'size')} >
                            <option>Size</option>
                            <option></option>
                            <option>6"</option>
                            <option>8"</option>
                            <option>10"</option>
                            <option>12"</option>
                            <option>14"</option>
                            <option>16"</option>
                        </select>
                    </td>
                    <td key={item.size}><input ref={setRef(`size_${index}`)} disabled={locked} type='text' name='size' defaultValue={item.size} /></td>
                    <td className="checklist-column"><Checklist /></td>
                </tr>
                <tr>
                    <td className='right' value='Shape' onChange={(e) => copyToText(e,'shape')} >
                        <select disabled={locked} >
                            <option>Shape</option>
                            <option></option>
                            <option>Square</option>
                            <option>Round</option>
                            <option>Oval</option>
                            <option>Rectangle</option>
                        </select>
                    </td>
                    <td key={item.shape}><input ref={setRef(`shape_${index}`)} disabled={locked} type='text' name='shape' defaultValue={item.shape} /></td>
                    <td className="checklist-column"><Checklist /></td>
                </tr>
                <tr>
                    <td className='right'><label>Message</label></td>
                    <td key={item.message}><input ref={setRef(`message_${index}`)} disabled={locked} name='message' defaultValue={item.message} /></td>
                    <td className="checklist-column"><Checklist /></td>
                </tr>
                <tr>
                    <td className='right top'><input className='right' disabled value='Notes' /></td>
                    <td key={item.notes}>
                        
                    {!locked && <textarea disabled={locked} ref={setRef(`notes_${index}`)} name='notes' defaultValue={item.notes} />}
                    {locked && <div style={{whiteSpace: 'pre-wrap'}}>{item.notes}</div>}
                    </td>
                    <td className="checklist-column"><Checklist /></td>
                </tr>

                <tr>
                    <td className='right'><label>Price</label></td>
                    <td key={item.unit_cost}><input  style={{width:80}} ref={setRef(`unit_cost_${index}`)} disabled={locked} name='unit_cost' defaultValue={penceToCurrency(item.unit_cost)} /></td>
                </tr>


                {order?.id ? <tr><td className='right'><label>Photo</label></td>
                    <td ><Photo order random={random} disabled={locked} bucket='customs' path={order.id} filename={index+1} onRemove={updateRandom} /></td>
                    <td className="checklist-column"><Checklist /></td>
                </tr> : ''}

            </table>
        </div>
    )
  }

  const notesToSave = !!Object.keys(noteChanges).find(k=>noteChanges[k].updated)
  
  const hasChanges = !!Object.entries(changes).length


  const theadStyle = order?.order_type === 1 ? {display:'table-row-group'} : {}



  return (
    <>

        {order?.id ? <Modal
          isShowing={showModal}
          title={<><FontAwesomeIcon icon={faTimes} />&nbsp;Void Order!&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
          hide={toggleModal}
        >
        <div className='center'>
          <h3>Really void ORDER {order?.id}?</h3><br/><br/>
          <button className='inv' disabled={voiding} onClick={doVoid}><FontAwesomeIcon spin={voiding} icon={voiding ? faSpinner : faTimes} />&nbsp;&nbsp;{voiding ? 'Please wait...' : 'VOID THIS ORDER'}</button>
          </div>
        </Modal> : ''}
        
        {order?.id ? <Modal
          isShowing={showDeleteModal}
          title={<><FontAwesomeIcon icon={faTrashAlt} />&nbsp;Delete Order!&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
          hide={toggleDeleteModal}
        >
        <div className='center'>
          <h3>Really delete ORDER {order?.id}?<br/><br/>THIS CANNOT BE UNDONE!</h3><br/><br/>
          <button className='inv' disabled={deleting} onClick={doDelete}><FontAwesomeIcon spin={deleting} icon={deleting ? faSpinner : faTrashAlt} />&nbsp;&nbsp;{deleting ? 'Please wait...' : 'DELETE THIS ORDER'}</button>
          </div>
        </Modal> : ''}

        {order?.id ? <Modal
          isShowing={showUnapproveModal}
          title={<><FontAwesomeIcon icon={faUserXmark} />&nbsp;Unapprove Order&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
          hide={toggleUnapproveModal}
        >
        <div className='center'>
          <h3>Really unapprove ORDER {order?.id}?</h3><br/><br/>
          <button className='inv' disabled={deleting} onClick={doUnapprove}><FontAwesomeIcon spin={approving} icon={approving ? faSpinner : faUserXmark} />&nbsp;&nbsp;{deleting ? 'Please wait...' : 'UNAPPROVE THIS ORDER'}</button>
          </div>
        </Modal> : ''}


        

        {selectingCopyDate ? <Modal
                    isShowing={selectingCopyDate}
                    title={'Copy to...'}
                    hide={onSelectDateCancelled}
                    >

            <Calendar
                onChange={onSelectDate}
                showNeighboringMonth={false}
                next2Label={null}
                date={currentDate}
                prev2Label={null}
                minDate={sub(currentDate, {months: 6})}
                maxDate={add(currentDate, {months: 6})}
            />    
            <h4 className='copying-message'>{copyingMessage} {copyDate && <button className='inv'  onClick={doCopy}>Copy order to {formatDate(copyDate)}</button>}</h4>   

            </Modal> : ''}

            {order?.id  ? <ul className='button-list'>
                {currentUser.p_orders>=2 && <li><button className='inv' disabled={order?.voided || !locked} onClick={duplicate}><FontAwesomeIcon icon={faCopy} />&nbsp;&nbsp;Duplicate</button></li>}
                {!order.approved_at && grandTotal !== 0 ? <li><button disabled={hasChanges} className='inv' onClick={toggleFormat}><FontAwesomeIcon icon={showInvoice ? faFileAlt  : faFileInvoiceDollar} />&nbsp;&nbsp;{showInvoice ? 'View Order' : 'View Invoice'}</button></li> : ''}
                
                {locked && currentUser?.admin && !order.approved_at && !order?.voided ? <li><button disabled={!locked || showInvoice} className='inv' onClick={adminUnlock}><FontAwesomeIcon icon={faLockOpen} />&nbsp;&nbsp;UNLOCK</button></li> : ''}
                {!locked && currentUser?.admin && !order.approved_at && !order?.voided ? <li><button disabled={locked || showInvoice || hasChanges} className='inv' onClick={adminLock}><FontAwesomeIcon icon={faLock} />&nbsp;&nbsp;LOCK</button></li> : ''}
 
                {currentUser?.admin && canApproveOrder(order) ? <li><button disabled={!locked} className='inv' onClick={adminApprove}><FontAwesomeIcon spin={approving} icon={approving ? faSyncAlt : faUserCheck} />&nbsp;&nbsp;APPROVE</button></li> : ''}
                {canUnapprove && order.approved_at ? <li><button disabled={!locked} className='inv' onClick={adminUnapprove}><FontAwesomeIcon icon={faUserXmark} />&nbsp;&nbsp;UNAPPROVE</button></li> : ''}
                
                {<li><button disabled={hasChanges} className='inv' onClick={doPrint}><FontAwesomeIcon icon={faPrint} />&nbsp;&nbsp;Print</button></li>}
                
                {!order.approved_at && (!pastCutOff || currentUser.admin) ? <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<button disabled={order?.voided} className='serious' onClick={handleVoid}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;VOID</button></li> : ''}         
                
                {!order.approved_at && currentUser.admin ? <li><button className='serious' onClick={handleDelete}><FontAwesomeIcon icon={faTrashAlt} />&nbsp;&nbsp;DELETE</button></li> : ''}         
                
                </ul> : ''}

            {order?.approved_at && <h3 className='approved no-print'><FontAwesomeIcon icon={faUserCheck} /> {displayUser(allUsers, order.approved_by)} APPROVED this invoice on {formatDate(order?.approved_at, true)}</h3>}
                            
                            
            <div key={`${shop.id}-${dateStr}-order`} className={`order ${showInvoice ? 'invoice' : ''} ${locked ? 'order-locked' : ''}`}>
                {order.voided ? <div className='voided-banner'>VOID</div> : ''}
            
                <table className='print-page'><thead style={theadStyle}><tr><th>
                {!loading && !showInvoice && statusMessage()}
                

                {showInvoice && order?.id && 
                
                <>
                    <table className='clear'>
                        
                    <tr>
                        <td className='top sixty' ><h1 >{order.approved_at ? 'Sales' : 'Pro Forma'} Invoice</h1><br/>
                            
                            <table className='invoice-details'>
                            <tr>
                                <td>Invoice number</td>
                                <td><strong onClick={viewOrder} >{order.id}</strong></td>
                            </tr>
                            <tr>
                                <td>Invoice date</td>
                                <td><strong>{format(currentDate, 'dd MMMM yyyy')}</strong></td>
                            </tr>

                            <tr>
                                <td>PO num</td>
                                <td><strong>{order?.purchase_order_num || ''}</strong></td>
                            </tr>
                            </table>
                        </td>
                        <td className='top right forty'>
                        <strong style={{textTransform:'uppercase'}}>{businessData.invoiceHeaderName}</strong><br/>
                            {businessData.address}<br/>
                            Tel: 020 8453 1397<br/>
                            Whatsapp support: 07765 403737<br/>
                            Email: admin@elnlondon.com<br/>
                        </td>
                    </tr>

                    
                    </table>

                    <table className='clear'>
                        <tr>
                            <td className='half'>Invoice to</td>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
                            <td className='half'>Deliver to</td>
                        </tr>

                        <tr>
                            <td className='top'><strong>{showBillingAddress()}</strong></td>
                            <td></td>
                            <td className='top'><strong>{showDeliveryAddress()}</strong></td>
                        </tr>
                    </table>    
                    
                </>}
                
                {!showInvoice && 
                <>
                    
                    <h1><span>{shop.brands?.name}</span>{shop.name}</h1>
                    {order?.order_type === 0 && 
                    <>
                    
                    <h2 className='forDelivery'>For Delivery On</h2>
                    <h1 style={{fontSize:28, fontWeight:'bold', textAlign:'center', marginTop: 0}}>{format(currentDate, 'PPPP')}</h1>
                
                    {!loading && showPurchaseOrderNum && <div className='order-header'>
                    PO num: &nbsp;&nbsp; 
                    {locked ? <b>{order?.purchase_order_num || ''}</b> : <input key={`${shop.id}-${dateStr}-ponum`} type='text' onChange={e => setOrder({...order, purchase_order_num: e.target.value})} disabled={locked} defaultValue={order?.purchase_order_num} />}
                
                    </div>}

                    <h2 className='orderNumber'>{order?.id ? <>Order number: &nbsp;<strong>{order.id}</strong></> : ''}</h2>
                    </>
                    }


                    {!order?.id ? <div className='center'>
                        <button class='link' onClick={switchType}><FontAwesomeIcon icon={order?.order_type === 1 ? faCheckSquare : faSquare} />&nbsp;&nbsp;Custom Order</button>
                        
                    </div> : ''}

                    {order?.order_type === 1 &&
                        <table className='clear custom-fields'>
                            <tr>
                                <td colspan='2'></td>
                                <td className='checklist-column'><Checklist labels /></td>
                            </tr>
                            <tr>
                                <td className='right'>Delivery date</td>
                                <td style={{fontSize:20, textTransform: 'uppercase', fontWeight:'bold'}}>{format(currentDate, 'PPPP')}</td>
                                <td className='checklist-column'><Checklist /></td>
                            </tr>
                            <tr>
                                <td className='right'>Order number</td>
                                <td style={{fontSize:20, textTransform: 'uppercase', fontWeight:'bold'}}>{order.id}</td>
                                <td><Checklist /></td>
                            </tr>
                            <tr>
                                <td className='right'>PO Number</td>
                                <td style={{fontSize:20, fontWeight:'bold'}}>{locked ? <b>{order?.purchase_order_num || ''}</b> : <input style={{width:280}} key={`${shop.id}-${dateStr}-ponum`} type='text' onChange={e => setOrder({...order, purchase_order_num: e.target.value})} disabled={locked} defaultValue={order?.purchase_order_num} />}
                                </td>
                                <td><Checklist /></td>
                            </tr>
                        </table>
                    }

                </>}

                </th></tr>
                
                </thead>
                <tbody>
                {!loading && order?.order_type === 0 && products.map((category) => {

                    const visibleProducts = filterProducts(category[1]);
    
                    if (visibleProducts.length === 0) return null

                    const productsToShow = visibleProducts.filter(product => {
                        const orderProduct = order?.orderProducts?.find(op => op.products.id === product.id)
                        let quantity = orderProduct ? orderProduct.quantity : 0;
                        if (changes[product.id]) quantity = changes[product.id].quantity;
                        return quantity > 0
                    })

                    if (locked && productsToShow.length === 0) return null

                    
                    return (
                        <>
                        <tr key={category[0]}><td className='category'><h3 className={`${visibleProducts.length === 0 ? 'zero' : ''}`}>{category[0].split('_').join('')}</h3><table className='clear'>
                        
                        {visibleProducts.map(product => {
                            
                            const shopProduct = product.shopProducts.find(s => s.shop_id === shop.id)

                            const isAvailable = order?.order_type === 1 ? true : !!shopProduct
                            const orderProduct = order?.orderProducts?.find(op => op.products.id === product.id)
                            
                            let quantity = orderProduct ? orderProduct.quantity : 0;
                            const quantity_imported = orderProduct ? orderProduct.quantity_imported : 0;

                            if (changes[product.id]) quantity = changes[product.id].quantity;

                            const isActive = product.active;

                            const isDisabled =  showInvoice || !isAvailable || !isActive || locked

                            const opCost = orderProduct?.unit_cost
                            const spCost = shopProduct?.unit_cost
                            const pCost = shop.brands.can_override_cost ? 0 : product.unit_cost


                            const recipe = order?.recipes?.find(r => r.pid === product.pid || r.pid === product.pid + RECIPE_PID_ADD || r.pid === product.pid + DISH_PID_ADD)

                            const unitCost = opCost || spCost || pCost || 0

                            let costClass = shop.brands.can_override_cost ? '' : 'p-cost'
                            if (spCost) costClass = 's-cost'
                            if (opCost) costClass = 'o-cost'

                            if (!currentUser.admin) costClass=''

                            const totalCost = unitCost * quantity

                            const handleChange = (e) => {
                                changeNote(product.id, e.target.value)
                            }


                            const isChanged = !!changes[product.id]

                            const viewRecipe = () => {
                                if (!recipe) return
                                history.push(`/spec-cards/USES%20${recipe.pid}`)
                            }

                            return (
                                <>
                                <tr className={`${quantity === 0 ? 'no-print' : ''}`}>
                                    <td className='order-row-td'>
                                        {recipe && currentUser.admin && currentUser.p_speccards >= 1 && <button className='recipe-link' onClick={viewRecipe}><FontAwesomeIcon icon={faSpoon} /></button>}
                                        <div key={`${shop.id}-${dateStr}-${product.id}`} className={`order-row ${!quantity  ? 'zero' : 'non-zero'} ${isChanged ? 'changed' : ''} ${!locked ? 'unlocked' : ''}`} >
                                            <input className={'product-name'}  name="product" disabled defaultValue={`${product.name} ${product.details ? `(${product.details})` : ''}`} />
                                            <input className='cost' disabled={isDisabled} onChange={e => changeQuantity(e, false,product.id, e.target.value, unitCost, quantity_imported)} onBlur={e => changeQuantity(e, true, product.id, e.target.value, unitCost, quantity_imported)} type="number" onClick={handleFocus}  min="0" name="quantity" defaultValue={quantity} />
                                            <input className={`cost ${costClass}`} disabled={true} readOnly name="unit_cost" value={penceToCurrency(unitCost)} />
                                            <input className={`cost total-cost`} disabled={true} readOnly name="total_cost" value={penceToCurrency(totalCost)} />
                                        </div>

                                    </td>
                                    
                                </tr>
                                {order?.order_type === 0 && noteChanges[product.id] && quantity && (editNotes || noteChanges[product.id].note?.length > 0) ? <tr className={`${noteChanges[product.id].note?.length === 0 ? 'no-print' : ''}`}>
                                    <td><input disabled={!editNotes} className={`note-input no-print ${noteChanges[product.id].updated ? 'note-input-updated' : ''}`} name="note" onChange={handleChange}  defaultValue={noteChanges[product.id].note} />
                                    <span className='note-printed print-only'>{noteChanges[product.id].note}</span></td>
                                    </tr> : ''}
                                </>
                            )
                        })}

                        </table></td></tr>
                        </>
                    )
                }
                )}

                {!loading && 
                <>
                
                    {order?.order_type === 1 && showInvoice ? 
                        <>{order?.orderCustoms?.map((c,i) => renderOrderCustomInvoiceRow(order.orderCustoms[i],i) )}</>
                    : ''}

                    {order?.order_type === 1 && !showInvoice ?
                        <tr><td>
                        <div className='custom-fields'>
                            {order?.orderCustoms?.map((c,i) => renderOrderCustom(order.orderCustoms[i],setRef,i) )}
                            
                            {!locked && !showInvoice ? <div className='custom-item center no-print'>
                                <button class='inv' disabled={locked} onClick={addCustom}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Add custom item</button>
                            </div> : ''}

                            <h3 className='center'>DELIVER TO</h3>
                            <table className='clear'>
                                <tr>
                                    <td colspan="2" className='center'>
                                        <label><input disabled={locked} type='radio' name='deliver_to_shop' value={true} defaultChecked={order?.deliver_to_shop !== false} onChange={e => setOrder({...order, deliver_to_shop: true})} /> <strong>{shop.brands?.name} {shop.name}</strong></label> &nbsp;&nbsp;&nbsp;&nbsp;
                                        <label><input disabled={locked} type='radio' name='deliver_to_shop' value={false} defaultChecked={order?.deliver_to_shop === false} onChange={e => setOrder({...order, deliver_to_shop: false})} /> <strong>Customer</strong></label>
                                    </td>
                                </tr>
                                

                                {order?.deliver_to_shop !== false ? '' : <>
                                <tr>
                                    <td className='right'>Customer name</td>
                                    <td ><input disabled={locked} name='delivery_customer' defaultValue={order?.delivery_customer} onChange={e => setOrder({...order, delivery_customer: e.target.value })} /></td>
                                    <td className="checklist-column"><Checklist /></td>
                                </tr>
                                <tr>
                                    <td className='right'>Customer company</td>
                                    <td ><input disabled={locked} name='delivery_company' defaultValue={order?.delivery_company} onChange={e => setOrder({...order, delivery_company: e.target.value })} /></td>
                                </tr>
                                <tr>
                                    <td className='right'>Customer telephone</td>
                                    <td ><input disabled={locked} name='delivery_tel' style={{width: '150px'}}  defaultValue={order?.delivery_tel} onChange={e => setOrder({...order, delivery_tel: e.target.value })} /></td>
                                </tr>
                                <tr>
                                    <td className='right'>Address line 1</td>
                                    <td ><input disabled={locked} name='delivery_line_1'  defaultValue={order?.delivery_line_1} onChange={e => setOrder({...order, delivery_line_1: e.target.value })} /></td>
                                </tr>
                                <tr>
                                    <td className='right'>Address line 2</td>
                                    <td ><input disabled={locked} name='delivery_line_2'  defaultValue={order?.delivery_line_2} onChange={e => setOrder({...order, delivery_line_2: e.target.value })} /></td>
                                </tr>
                                <tr>
                                    <td className='right'>Address line 3</td>
                                    <td ><input disabled={locked} name='delivery_line_3' defaultValue={order?.delivery_line_3} onChange={e => setOrder({...order, delivery_line_3: e.target.value })} /></td>
                                </tr>
                                <tr>
                                    <td className='right'>Town / city</td>
                                    <td ><input disabled={locked} name='delivery_city'  defaultValue={order?.delivery_city} onChange={e => setOrder({...order, delivery_city: e.target.value })} /></td>
                                </tr>
                                <tr>
                                    <td className='right'>Postcode</td>
                                    <td ><input disabled={locked} name='delivery_postcode' style={{width: '150px'}} defaultValue={order?.delivery_postcode} onChange={e => setOrder({...order, delivery_postcode: e.target.value })} /></td>
                                </tr>
                                </>}
                            </table>

                        </div>
                        </td></tr>
                    
                : null}

                    


                    {order?.order_type === 0 && !showInvoice ? <>
                        
                        <tr><td><div className='order-row total-row-before'>
                        {!locked && Object.entries(changes).length ? <>
                            <input style={{width:'100%'}} disabled readOnly value='' />
                            <input className='cost' disabled type="number" readOnly value={beforeTotals.quantityCount}/>
                            <input className='cost' disabled readOnly  />
                            <input className='cost total-cost'  disabled readOnly value={penceToCurrency(beforeTotals.totalCount, false)} />
                        </> : ''}
                        </div></td></tr>
                        <tr>
                            <td><div className='order-row total-row'>
                        <input style={{width:'100%'}} disabled readOnly value='TOTAL' />
                        <input className='cost' disabled type="number" readonly value={quantityCount}/>
                        <input className='cost' disabled readOnly  />
                        <input className='cost total-cost'  disabled readOnly value={penceToCurrency(grandTotal, false)} />
                        </div></td></tr>
                    
                    </> : ''}

                    

                    {showInvoice && <tr><td><br/><br/>
                    <div className='invoice-total-row'>
                        <input style={{width:'100%'}} disabled readOnly value='NET AMOUNT £' />
                        <input className='cost total-cost'  disabled readOnly value={penceToCurrency(grandTotal, false)} />
                    </div>
                    <div className='invoice-total-row'>
                        <input style={{width:'100%'}} disabled readOnly value='VAT AMOUNT £' />
                        <input className='cost total-cost'  disabled readOnly value='0.00' />
                    </div>
                    <div className='invoice-total-row total'>
                        
                        <input style={{width:'90%'}} disabled readOnly value='TOTAL £' />
                        <input className='cost total-cost'  disabled readOnly value={penceToCurrency(grandTotal, false)} />
                    </div>
                    </td></tr>}

                    
                    {showInvoice && order?.order_type === 0 && <tr><td><br/>
                        
                        {currentUser.admin && <button disabled={editNotes && notesToSave} className={editNotes ? 'inv' : ''} onClick={toggleNotes}><FontAwesomeIcon icon={faPencil} />&nbsp;&nbsp;Notes</button>}
    
                
                        {currentUser.admin && editNotes ? <>&nbsp;&nbsp;<button onClick={handleNotesSubmit} disabled={!notesToSave} className='inv'><FontAwesomeIcon spin={saving} icon={saving ? faSyncAlt : faSave} />&nbsp;Save notes</button></> : ''}
                    
                    </td></tr>}

                    {!showInvoice && 
                    <tr><td>
                        {(!locked) && <>
                        <br/>
                        <h3 className='center'>Special instructions</h3>
                        <div className='center' style={{margin: '0px 20px'}}>
                            <textarea className='special' key={`${shop.id}-${dateStr}-special`} onChange={e => setOrder({...order, notes:e.target.value})} disabled={locked} defaultValue={order?.notes || ''} />
                        </div>
                        </>}
                        {(locked && order?.notes) && <>
                        <br/>
                        <h3 className='center'>Special instructions</h3>
                        <div className='center' style={{margin: '0px 20px', whiteSpace: 'pre-wrap'}}>{order?.notes}</div>
                        </>}


                        {!showInvoice && order?.order_type === 1 &&
                        <>
                        <br/>
                        
                        <table className='final-quality-control'>
                            <tbody>
                            <tr>
                                <th colspan='3'><h3 className='center'>Final Quality Control</h3></th>
                            </tr>
                            <tr>
                                <th>Stage</th>
                                <th>Checked by</th>
                                <th>Date</th>
                            </tr>
                            <tr>
                                <td>Order confirmed correct (office)</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Cake produced as per spec</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Message verified</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Decoration matches photo</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Boxed and labelled correctly</td>
                                <td></td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>
                        </>
                        }


                        <div className='no-print' style={{marginTop:30, width:'100%', display:'flex', flexDirection:'column', alignItems:'center', textAlign:'center'}}>
                            
                            
                            
                            {!locked && currentUser.p_orders>=2 && <button disabled={saving} className='large inv' onClick={order?.order_type === 0 ? handleSubmit : handleCustomSubmit}>
                            <div><FontAwesomeIcon spin={saving} icon={saving ? faSyncAlt : faSave} />&nbsp;{order?.id ? `Change this order` : `Create new order`}</div>
                                <h2>for delivery on {formatDate(currentDate)}</h2>
                            </button>
                            }
                            {order?.id && <div className='changes'></div>}
                            <div className='temporary'>{temporary}</div>
                            
                            
                            <br/>
                            {statusMessage()}
                        </div>
                    </td></tr>
                    }

                    
                </>
                }
            
                </tbody>
                {showInvoice && order?.id && <tfoot><div class='empty-footer'></div></tfoot>}
                </table>

                {showInvoice && order?.id && 
                <div class='invoice-footer'>
                    <b>{businessData.invoiceFooterName}</b><br/>
                    Registered in England and Wales. Company Number: <b>{businessData.registrationNumber}</b>
                    {businessData.vatNumber && <> &nbsp;&nbsp;&nbsp; VAT Registration Number: <b>{businessData.vatNumber}</b></>}<br/>
                    Registered Address: <b>{businessData.registeredAddress}</b><br/><br/>
                    Business Current Account Name: <b>{businessData.accountName}</b> &nbsp;&nbsp;&nbsp; 
                    Sort Code: <b>{businessData.sortCode}</b> &nbsp;&nbsp;&nbsp; Account Number: <b>{businessData.accountNo}</b><br/>
                </div>
                }

            </div>

            <div className='order-dates no-print'>

                {showInvoice && order.notes && <h4>Special instructions:<br/><i style={{color:'#000'}}>{order.notes}</i><br/><br/></h4>}
                {order?.created_at && <h4>created: {formatDate(order?.created_at, true)} by {displayUser(allUsers, order?.created_by)}<br/></h4>}
                {order?.imported_at && <h4>last imported: {formatDate(order?.imported_at, true)} {order.imported_by && <>by {displayUser(allUsers, order.imported_by)}</>}</h4>}
                {order?.updated_at && <h4>last updated: {formatDate(order?.updated_at, true)} {order.updated_by && <>by {displayUser(allUsers, order.updated_by)}</>}</h4>}
                {order?.voided && <h4>voided: {formatDate(order?.voided_at, true)} {order.voided_by && <>by {displayUser(allUsers, order.voided_by)}</>}</h4>}

                {order?.approved_at && <h4>approved: {formatDate(order?.approved_at, true)} {order.approved_by && <>by {displayUser(allUsers, order.approved_by)}</>}</h4>}
                            

            </div>
            {order?.imported_at && !showInvoice && order?.is_altered ? <><br/>
                            <div className='changes-from-import no-print'>
                                <h3><div title='This order has changed since import' className='changes-since-import'><FontAwesomeIcon icon={faAsterisk} /></div> Current differences compared to PW import:</h3>
                                <table>
                                {order?.orderProducts.sort((a,b) => a.updated_at > b.updated_at ? 1 : -1).map(p => {  
                                    let change = <></>
                                    if (p.quantity === p.quantity_imported) return null

                                    if (p.quantity_imported && p.quantity) change = <>quantity changed from {p.quantity_imported} to {p.quantity}</>
                                    else if (p.quantity_imported) change = <>{p.quantity_imported} removed</>
                                    else if (p.quantity) change = <>{p.quantity} added</>
                                    
                                    return <tr><td>{p.products.name}</td><td>{change}</td><td>{displayUser(allUsers, p.updated_by)}</td><td>{formatDate(p.updated_at, true)}</td></tr>
                                })}
                                </table>
                            </div>
                            </> : ''}
        

    </>
  )
}

export default withRouter(OrderForm);
